import { Container } from "@fideus-ui/core";
import { createFileRoute } from "@tanstack/react-router";
import { TechTaxEntryTab } from "../../../../companies/masterData/TechTaxEntryTab";

export const Route = createFileRoute(
  "/firmen/$companyId/stammdaten/techtax-eintragen"
)({
  loader: async ({ context: { queryClient, trpc }, params: { companyId } }) => {
    void queryClient.ensureQueryData(
      trpc.companies.getCompany.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.companies.getCompanyAddress.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.companies.getCommercialRegisterEntry.queryOptions({ companyId })
    );
    void queryClient.ensureQueryData(
      trpc.clients.listUsersWithCompanyAccess.queryOptions({ companyId })
    );
  },
  component: TechTaxEintragenRoute,
});

function TechTaxEintragenRoute() {
  const { companyId } = Route.useParams();
  return (
    <Container>
      <TechTaxEntryTab companyId={companyId} />
    </Container>
  );
}
